import React, { useEffect, useState } from 'react'
import makeStyles from '@mui/styles/makeStyles'
import clsx from 'clsx'
import { Badge, IconButton, Tooltip } from '@mui/material'
import { Link, useLocation } from 'react-router-dom'
import {
    useGetDoctorRequiredExpertIdConsultations,
    useGetDoctorRequiredExpertIdTransmissions,
} from '@toktokdoctech/tokapi-client'
import styles from './styles/PrimaryHeaderMenuStyles'
import { ConsultationsPageLoadable, HistoryLoadable, TransmissionsPageLoadable } from '../../../lazyLoading'
import {
    ConsultationsIcon,
    TransmissionsIcon,
    NewsIcon,
    HistoryIcon,
    ConsultationsIconActive,
    TransmissionsIconActive,
    NewsActiveIcon,
    HistoryIconActive,
} from '../../../../assets/icons'
import { useAppSelector } from '../../../store'

// @ts-expect-error TS(2345) FIXME: Argument of type '(theme: any) => { PrimaryHeaderM... Remove this comment to see the full error message
const useStyles = makeStyles(styles)

// data is only used to get total count of pending and started transmissions, so we can set limit to 1 to reduce payload size
const FETCH_LIMIT = 1

const PrimaryHeaderMenu = () => {
    const classes = useStyles()
    const location = useLocation()
    const [active, setActive] = useState('')
    let previousScrollPos = 0
    const { objectId: userObjectId } = useAppSelector((state) => state.auth.user)

    const { data: transmissions } = useGetDoctorRequiredExpertIdTransmissions(
        userObjectId ?? '',
        {
            limit: FETCH_LIMIT,
            status: 'transmited',
        },
        {
            query: {
                queryKey: ['transmissions-count', userObjectId],
            },
        }
    )

    const { data: pendingConsultations } = useGetDoctorRequiredExpertIdConsultations(
        userObjectId ?? '',
        {
            limit: FETCH_LIMIT,
            status: 'pending',
        },
        {
            query: {
                queryKey: ['pendingConsultations-count', userObjectId],
            },
        }
    )
    const { data: startedConsultations } = useGetDoctorRequiredExpertIdConsultations(
        userObjectId ?? '',
        {
            limit: FETCH_LIMIT,
            status: 'started',
        },
        {
            query: {
                queryKey: ['startedConsultations-count', userObjectId],
            },
        }
    )

    const tcTotal = (pendingConsultations?.total ?? 0) + (startedConsultations?.total ?? 0)

    const hideAndShowHeaderOnWindowScroll = () => {
        const uxHeaderMenu = document.querySelector('#ux_primary_header_menu')
        const currentScroll = window.scrollY

        if (uxHeaderMenu) {
            if (currentScroll <= 0) {
                uxHeaderMenu.classList.remove('ux_primary_header_menu_hidden')
            }
            // up so we display header
            if (currentScroll > previousScrollPos && currentScroll > 85) {
                uxHeaderMenu.classList.add('ux_primary_header_menu_hidden')
                // down so we hide header
            } else if (currentScroll < previousScrollPos) {
                uxHeaderMenu.classList.remove('ux_primary_header_menu_hidden')
            }
            previousScrollPos = currentScroll
        }
    }

    window.onscroll = hideAndShowHeaderOnWindowScroll

    useEffect(() => {
        setActive(location.pathname)
    }, [location.pathname])

    const navigationButtons = [
        {
            icon: <ConsultationsIcon />,
            activeIcon: <ConsultationsIconActive />,
            notifications: tcTotal,
            tooltipText: 'Téléconsultations',
            id: 1,
            path: '/consultations',
            preload: () => ConsultationsPageLoadable.preload(),
            cy: 'headBtnConsultations',
        },
        {
            icon: <TransmissionsIcon />,
            activeIcon: <TransmissionsIconActive />,
            notifications: transmissions?.total,
            tooltipText: 'Téléexpertises',
            id: 2,
            path: '/transmissions',
            preload: () => TransmissionsPageLoadable.preload(),
            cy: 'headBtnTransmissions',
        },
        {
            icon: <HistoryIcon />,
            activeIcon: <HistoryIconActive />,
            notifications: 0,
            tooltipText: 'Historique',
            id: 3,
            path: '/history',
            preload: () => HistoryLoadable.preload(),
            cy: 'headBtnHistory',
        },
        {
            icon: <NewsIcon />,
            activeIcon: <NewsActiveIcon />,
            notifications: 0,
            tooltipText: 'Actualités',
            id: 4,
            path: '/news',
            cy: 'headBtnNews',
        },
    ]

    return (
        <div className={classes.PrimaryHeaderMenu} id="ux_primary_header_menu">
            <div className={classes.PrimaryHeaderMenuNavigation}>
                {navigationButtons.map((button) => (
                    <Tooltip
                        disableInteractive
                        data-cy={button.cy}
                        key={button.id}
                        title={button.tooltipText}
                        aria-label={button.tooltipText}
                        // @ts-expect-error TS(2322) FIXME: Type '{ children: Element; "data-cy": string; key:... Remove this comment to see the full error message
                        position="bottom"
                        arrow
                    >
                        <Link
                            to={button.path}
                            key={button.id}
                            aria-label={button.tooltipText}
                            onMouseOver={() => {
                                button.preload?.()
                            }}
                        >
                            <IconButton
                                aria-label={button.tooltipText}
                                className={clsx(
                                    classes.PrimaryHeaderMenuNavigationIconButton,
                                    active === button.path ? classes.PrimaryHeaderMenuNavigationIconButtonActive : ''
                                )}
                                size="large"
                            >
                                {active === button.path ? button.activeIcon : button.icon}
                                <Badge
                                    classes={{
                                        badge: classes.PrimaryHeaderMenuNavigationNotificationIcon,
                                    }}
                                    badgeContent={button.notifications}
                                    max={999}
                                />
                            </IconButton>
                        </Link>
                    </Tooltip>
                ))}
            </div>
        </div>
    )
}

export default PrimaryHeaderMenu
